import CalendarItemUser from "./CalendarItemUser";

export default ({
  id,
  name,
  color,
  users,
  visible,
  iCanEdit,
  onClickVisible,
  onClickCalendar,
}) => {
  return (
    <div className="calendar-menu-body">
      <div className="calendar-menu-calendar-view">
        <div className="calendar-menu-calendar-view-info">
          <div
            className="calendar-color"
            style={
              visible
                ? { backgroundColor: color }
                : {
                    backgroundColor: "white",
                    borderColor: color,
                    borderWidth: 2,
                    borderStyle: "solid",
                  }
            }
          ></div>
          <img
            src={
              visible
                ? "/images/support-extra/eye-open.svg"
                : "/images/support-extra/eye-closed.svg"
            }
            loading="lazy"
            alt=""
            className="calendar-view"
            onClick={onClickVisible}
          />
          <div
            className={`calendar-name ${iCanEdit ? "clickable-calendar" : ""}`}
            style={{ color: visible ? "unset" : "lightgray" }}
            onClick={iCanEdit ? () => onClickCalendar(id) : null}
          >
            {name}
          </div>
        </div>
        <div className="calendar-menu-calendar-view-user">
          {users.length > 1 &&
            users.map((user) => {
              return (
                <CalendarItemUser
                  key={user.id}
                  icon={user.pic}
                  name={user.name}
                  lastName={user.lastName}
                  calendarColor={color}
                  readOnly={user.readOnly}
                  showTitle={true}
                />
              );
            })}
        </div>
      </div>
    </div>
  );
};
